import Contract from "components/Contract";
import CrmLead from "components/CrmLead";
import PageNotFound from "components/PageNotFound";
import PaymentMethodByCustomer from "components/PaymentMethodByCustomer";
import QrHeadquarters from "components/QrHeadquarters";
import QuoteSignature from "components/QuoteSignature";
import Tokenization from "components/Tokenization";
import TokenizationTransaction from "components/TokenizationTransaction";
import UnderAgeConcent from "components/UnderAgeConcent";
import Contact from "pages/Contact";
import FormGuestEvent from "pages/FormGuestEvent";
import FormQuotes from "pages/FormQuotes";
import PaymentLink from "pages/PaymentLink";
import Proposal from "pages/Proposal";
import ShoppingExpres from "pages/ShoppingExpress";
import DetailShoppingExpress from "pages/ShoppingExpress/DetailShoppingExpress";
import Surveys from "pages/Surveys";
import RatingTicket from "pages/ticket";

export const routes = [
  {
    path: "/contracts",
    element: (props) => <Contract {...props} />,
  },
  {
    path: "/token",
    element: (props) => <Tokenization {...props} />,
  },
  {
    path: "/update_payment_methods",
    element: (props) => <PaymentMethodByCustomer {...props} />,
  },
  {
    path: "/under-age-consent",
    element: (props) => <UnderAgeConcent {...props} />,
  },
  {
    path: "/createLead",
    element: (props) => <CrmLead {...props} />,
  },
  {
    path: "/payment-link",
    element: (props) => <PaymentLink {...props} />,
  },
  {
    path: "/tokenization-transaction",
    element: (props) => <TokenizationTransaction {...props} />,
  },
  {
    path: "/qr",
    element: (props) => <QrHeadquarters {...props} />,
  },
  {
    path: "/quotes",
    element: (props) => <QuoteSignature {...props} />,
  },
  {
    path: "/contact",
    element: (props) => <Contact {...props} />,
  },
  {
    path: "/form-quotes",
    element: (props) => <FormQuotes {...props} />,
  },
  {
    path: "/form-event-ticket",
    element: (props) => <FormGuestEvent {...props} />,
  },
  {
    path: "/shopping-express",
    element: (props) => <ShoppingExpres {...props} />,
  },
  {
    path: "/payment-shopping-express",
    element: (props) => <DetailShoppingExpress {...props} />,
  },
  {
    path: "/survey/reponse",
    element: (props) => <Surveys props={props} />,
  },
  {
    path: "/rating-ticket",
    element: (props) => <RatingTicket props={props} />,
  },
  {
    'path': '/proposal',
    'element': (props) => <Proposal props={props} />
  },
  {
    path: "*",
    element: () => <PageNotFound />,
  },
];

